import { Section, Text } from "@react-email/components";
import useThemeContextualColors, {
  sectionToParent,
} from "../../hooks/use-theme-contextual-colors";
import { tLayout } from "../../translations";
import { useReturnVariableValues } from "../../hooks/use-return-variable-values";
import type { ReturnRequestDateBlockProps } from "./types";

export function ReturnRequestDateEmailRenderer({
  theme,
  section,
  locale,
  defaultLocale,
}: ReturnRequestDateBlockProps) {
  const colors = useThemeContextualColors(theme, sectionToParent(section));
  const t = tLayout(locale, defaultLocale);
  const { requestDate, requestTime } = useReturnVariableValues().getRequestDate();

  // Rendered only for European customers (where the backend resolved a
  // trustworthy local date/time); otherwise nothing — mirrors the legacy
  // `ReturnRequestDate` component.
  if (!requestDate || !requestTime) return null;

  return (
    <Section className="px-4">
      <Text
        className="m-0 text-base leading-[1.5] text-center"
        style={{ color: colors.text }}
      >
        {t("returnRequestDate.label", {
          date: requestDate,
          time: requestTime,
        })}
      </Text>
    </Section>
  );
}
